import React from 'react';
interface StickyWebinarButtonProps {
  targetHeadingText: string;
}
export const StickyWebinarButton: React.FC<StickyWebinarButtonProps> = ({
  targetHeadingText
}) => {
  // Get today's date in format "10 nov"
  const getTodayDate = () => {
    const today = new Date();
    const day = today.getDate();
    const months = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
    const month = months[today.getMonth()];
    return `${day} ${month}`;
  };
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white flex justify-center border-t border-gray-200" data-id="element-370">
      <div className="w-full md:w-auto flex flex-col items-center" data-id="element-371">
        <p className="text-gray-700 text-sm mb-2" data-id="element-372">
          Vandaag {getTodayDate()} • 10:00, 13:00 of 20:00
        </p>
        <a href="https://stresslessdogs.nl/mcc-gpm-adv1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-green-600 hover:bg-green-700 py-4 px-6 text-center rounded-xl shadow-lg transition-colors duration-200" data-id="element-373">
          <span className="text-white font-bold text-base" data-id="element-374">
            Gratis Webinar: Communiceren Met Je Hond (zonder straffen)
          </span>
        </a>
      </div>
    </div>;
};